var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const EMPTY = "";
const UNDEF_TYPE = "undefined";
const OBJ_TYPE = "object";
const STR_TYPE = "string";
const UNKNOWN = "?";
const FUNC_TYPE = "function";
const UA_DEVICE = "device";
const UA_OS = "os";
const UA_RESULT = "result";
const MODEL = "model";
const NAME = "name";
const TYPE = "type";
const VENDOR = "vendor";
const VERSION = "version";
const MOBILE = "mobile";
const TABLET = "tablet";
const AMAZON = "Amazon";
const APPLE = "Apple";
const ASUS = "ASUS";
const BLACKBERRY = "BlackBerry";
const GOOGLE = "Google";
const HUAWEI = "Huawei";
const LG = "LG";
const MICROSOFT = "Microsoft";
const MOTOROLA = "Motorola";
const SAMSUNG = "Samsung";
const SHARP = "Sharp";
const SONY = "Sony";
const XIAOMI = "Xiaomi";
const ZEBRA = "Zebra";
const CHROME = "Chrome";
const FIREFOX = "Firefox";
const WINDOWS = "Windows";
const ARCHITECTURE = "architecture";
const BRANDS = "brands";
const FULLVERLIST = "fullVersionList";
const PLATFORM = "platform";
const PLATFORMVER = "platformVersion";
const BITNESS = "bitness";
const CH_HEADER = "sec-ch-ua";
const CH_HEADER_FULL_VER_LIST = CH_HEADER + "-full-version-list";
const CH_HEADER_ARCH = CH_HEADER + "-arch";
const CH_HEADER_BITNESS = CH_HEADER + "-bitness";
const CH_HEADER_MOBILE = CH_HEADER + "-mobile";
const CH_HEADER_MODEL = CH_HEADER + "-model";
const CH_HEADER_PLATFORM = CH_HEADER + "-platform";
const CH_HEADER_PLATFORM_VER = CH_HEADER_PLATFORM + "-version";
const UA_BROWSER = "browser";
const MAJOR = "major";
const PREFIX_MOBILE = "Mobile ";
const OPERA = "Opera";
const FACEBOOK = "Facebook";
const SUFFIX_BROWSER = " Browser";
const CH_ALL_VALUES = [
  BRANDS,
  FULLVERLIST,
  MOBILE,
  MODEL,
  PLATFORM,
  PLATFORMVER,
  ARCHITECTURE,
  BITNESS
];
const oldSafariMap = {
  "1.0": "/8",
  "1.2": "/1",
  "1.3": "/3",
  "2.0": "/412",
  "2.0.2": "/416",
  "2.0.3": "/417",
  "2.0.4": "/419",
  "?": "/"
};
const UA_MAX_LENGTH = 350;
const strMapper = function(str, map) {
  for (const i in map) {
    if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
      for (let j = 0; j < map[i].length; j++) {
        if (has(map[i][j], str)) {
          return i === UNKNOWN ? void 0 : i;
        }
      }
    } else if (has(map[i], str)) {
      return i === UNKNOWN ? void 0 : i;
    }
  }
  return str;
};
const assignFromEntries = function(obj, arr) {
  for (const i in arr) {
    const propName = arr[i];
    if (typeof propName === OBJ_TYPE && propName.length == 2) {
      obj[propName[0]] = propName[1];
    } else {
      obj[propName] = void 0;
    }
  }
  return obj;
};
const has = function(str1, str2) {
  if (typeof str1 === OBJ_TYPE && str1.length > 0) {
    for (const i in str1) {
      if (lowerize(str1[i]) == lowerize(str2))
        return true;
    }
    return false;
  }
  return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
};
const itemListToArray = function(header) {
  if (!header)
    return void 0;
  const arr = [];
  const tokens = strip(/\\?\"/g, header).split(", ");
  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i].split(";v=");
    arr[i] = { brand: token[0], version: token[1] };
  }
  return arr;
};
const lowerize = function(str) {
  return typeof str === STR_TYPE ? str.toLowerCase() : str;
};
const majorize = function(version) {
  return typeof version === STR_TYPE ? strip(/[^\d\.]/g, version).split(".")[0] : void 0;
};
const strip = function(pattern, str) {
  return str.replace(pattern, EMPTY);
};
const stripQuotes = function(val) {
  return typeof val === STR_TYPE ? strip(/\"/g, val) : val;
};
const trim = function(str, len) {
  if (typeof str === STR_TYPE) {
    str = strip(/^\s\s*/, str);
    return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
  }
  return EMPTY;
};
const rgxMapper = function(data, ua, arrays) {
  if (!ua || !arrays)
    return;
  let i = 0;
  let j;
  let k;
  let p;
  let q;
  let matches;
  let match;
  while (i < arrays.length && !matches) {
    const regex = arrays[i];
    const props = arrays[i + 1];
    j = k = 0;
    while (j < regex.length && !matches) {
      if (!regex[j]) {
        break;
      }
      matches = regex[j++].exec(ua);
      if (matches) {
        for (p = 0; p < props.length; p++) {
          match = matches[++k];
          q = props[p];
          if (typeof q === OBJ_TYPE && q.length > 0) {
            if (q.length === 2) {
              if (typeof q[1] === FUNC_TYPE) {
                data[q[0]] = q[1].call(data, match);
              } else {
                data[q[0]] = q[1];
              }
            } else if (q.length === 3) {
              if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                data[q[0]] = match ? q[1].call(data, match, q[2]) : void 0;
              } else {
                data[q[0]] = match ? match.replace(q[1], q[2]) : void 0;
              }
            } else if (q.length === 4) {
              data[q[0]] = match ? q[3].call(data, match.replace(q[1], q[2])) : void 0;
            }
          } else {
            data[q] = match || void 0;
          }
        }
      }
    }
    i += 2;
  }
};
const windowsVersionMap = {
  ME: "4.90",
  "NT 3.11": "NT3.51",
  "NT 4.0": "NT4.0",
  2e3: "NT 5.0",
  XP: ["NT 5.1", "NT 5.2"],
  Vista: "NT 6.0",
  7: "NT 6.1",
  8: "NT 6.2",
  8.1: "NT 6.3",
  10: ["NT 6.4", "NT 10.0"],
  RT: "ARM"
};
const browserRegexes = [
  [
    /\b(?:crmo|crios)\/([\w\.]+)/i
  ],
  [VERSION, [NAME, "Chrome"]],
  [
    /edg(?:e|ios|a)?\/([\w\.]+)/i
  ],
  [VERSION, [NAME, "Edge"]],
  [
    /(opera mini)\/([-\w\.]+)/i,
    /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
    /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
  ],
  [NAME, VERSION],
  [
    /opios[\/ ]+([\w\.]+)/i
  ],
  [VERSION, [NAME, OPERA + " Mini"]],
  [
    /\bopr\/([\w\.]+)/i
  ],
  [VERSION, [NAME, OPERA]],
  [
    /(kindle)\/([\w\.]+)/i,
    /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
    /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
    /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
    /(?:ms|\()(ie) ([\w\.]+)/i,
    /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
    /(heytap|ovi)browser\/([\d\.]+)/i,
    /(weibo)__([\d\.]+)/i
  ],
  [NAME, VERSION],
  [
    /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
  ],
  [VERSION, [NAME, "UCBrowser"]],
  [
    /microm.+\bqbcore\/([\w\.]+)/i,
    /\bqbcore\/([\w\.]+).+microm/i
  ],
  [VERSION, [NAME, "WeChat(Win) Desktop"]],
  [
    /micromessenger\/([\w\.]+)/i
  ],
  [VERSION, [NAME, "WeChat"]],
  [
    /konqueror\/([\w\.]+)/i
  ],
  [VERSION, [NAME, "Konqueror"]],
  [
    /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
  ],
  [VERSION, [NAME, "IE"]],
  [
    /ya(?:search)?browser\/([\w\.]+)/i
  ],
  [VERSION, [NAME, "Yandex"]],
  [
    /(avast|avg)\/([\w\.]+)/i
  ],
  [[NAME, /(.+)/, "$1 Secure" + SUFFIX_BROWSER], VERSION],
  [
    /\bfocus\/([\w\.]+)/i
  ],
  [VERSION, [NAME, FIREFOX + " Focus"]],
  [
    /\bopt\/([\w\.]+)/i
  ],
  [VERSION, [NAME, OPERA + " Touch"]],
  [
    /coc_coc\w+\/([\w\.]+)/i
  ],
  [VERSION, [NAME, "Coc Coc"]],
  [
    /dolfin\/([\w\.]+)/i
  ],
  [VERSION, [NAME, "Dolphin"]],
  [
    /coast\/([\w\.]+)/i
  ],
  [VERSION, [NAME, OPERA + " Coast"]],
  [
    /miuibrowser\/([\w\.]+)/i
  ],
  [VERSION, [NAME, "MIUI" + SUFFIX_BROWSER]],
  [
    /fxios\/([\w\.-]+)/i
  ],
  [VERSION, [NAME, PREFIX_MOBILE + FIREFOX]],
  [
    /\bqihu|(qi?ho?o?|360)browser/i
  ],
  [[NAME, "360" + SUFFIX_BROWSER]],
  [/(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i],
  [[NAME, /(.+)/, "$1" + SUFFIX_BROWSER], VERSION],
  [
    /(comodo_dragon)\/([\w\.]+)/i
  ],
  [[NAME, /_/g, " "], VERSION],
  [
    /(electron)\/([\w\.]+) safari/i,
    /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
    /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
  ],
  [NAME, VERSION],
  [
    /(metasr)[\/ ]?([\w\.]+)/i,
    /(lbbrowser)/i,
    /\[(linkedin)app\]/i
  ],
  [NAME],
  [
    /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
  ],
  [[NAME, FACEBOOK], VERSION],
  [
    /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
    /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
    /safari (line)\/([\w\.]+)/i,
    /\b(line)\/([\w\.]+)\/iab/i,
    /(chromium|instagram)[\/ ]([-\w\.]+)/i
  ],
  [NAME, VERSION],
  [
    /\bgsa\/([\w\.]+) .*safari\//i
  ],
  [VERSION, [NAME, "GSA"]],
  [
    /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
  ],
  [VERSION, [NAME, "TikTok"]],
  [
    /headlesschrome(?:\/([\w\.]+)| )/i
  ],
  [VERSION, [NAME, CHROME + " Headless"]],
  [
    / wv\).+(chrome)\/([\w\.]+)/i
  ],
  [[NAME, CHROME + " WebView"], VERSION],
  [
    /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
  ],
  [VERSION, [NAME, "Android" + SUFFIX_BROWSER]],
  [
    /chrome\/([\w\.]+) mobile/i
  ],
  [VERSION, [NAME, "Chrome"]],
  [
    /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
  ],
  [NAME, VERSION],
  [
    /version\/([\w\.\,]+) .*mobile(?:\/\w+ | ?)safari/i
  ],
  [VERSION, [NAME, PREFIX_MOBILE + "Safari"]],
  [/iphone .*mobile(?:\/\w+ | ?)safari/i],
  [[NAME, PREFIX_MOBILE + "Safari"]],
  [
    /version\/([\w\.\,]+) .*(safari)/i
  ],
  [VERSION, NAME],
  [
    /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
  ],
  [NAME, [VERSION, strMapper, oldSafariMap]],
  [/(webkit|khtml)\/([\w\.]+)/i],
  [NAME, VERSION],
  [
    /(?:mobile|tablet);.*(firefox)\/([\w\.-]+)/i
  ],
  [[NAME, PREFIX_MOBILE + FIREFOX], VERSION],
  [
    /(navigator|netscape\d?)\/([-\w\.]+)/i
  ],
  [[NAME, "Netscape"], VERSION],
  [
    /mobile vr; rv:([\w\.]+)\).+firefox/i
  ],
  [VERSION, [NAME, FIREFOX + " Reality"]],
  [
    /ekiohf.+(flow)\/([\w\.]+)/i,
    /(swiftfox)/i,
    /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
    /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
    /(firefox)\/([\w\.]+)/i,
    /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
    /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
    /(links) \(([\w\.]+)/i,
    /panasonic;(viera)/i
  ],
  [NAME, VERSION],
  [
    /(cobalt)\/([\w\.]+)/i
  ],
  [NAME, [VERSION, /[^\d\.]+./, EMPTY]]
];
const deviceRegexes = [
  [
    /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
  ],
  [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]],
  [
    /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
    /samsung[- ]([-\w]+)/i,
    /sec-(sgh\w+)/i
  ],
  [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]],
  [
    /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
  ],
  [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]],
  [
    /\((ipad);[-\w\),; ]+apple/i,
    /applecoremedia\/[\w\.]+ \((ipad)/i,
    /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
  ],
  [MODEL, [VENDOR, APPLE], [TYPE, TABLET]],
  [/(macintosh);/i],
  [MODEL, [VENDOR, APPLE]],
  [
    /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
  ],
  [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]],
  [
    /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
  ],
  [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]],
  [
    /(?:huawei|honor)([-\w ]+)[;\)]/i,
    /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
  ],
  [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]],
  [
    /\b(poco[\w ]+)(?: bui|\))/i,
    /\b; (\w+) build\/hm\1/i,
    /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
    /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
    /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
  ],
  [
    [MODEL, /_/g, " "],
    [VENDOR, XIAOMI],
    [TYPE, MOBILE]
  ],
  [
    /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
  ],
  [
    [MODEL, /_/g, " "],
    [VENDOR, XIAOMI],
    [TYPE, TABLET]
  ],
  [
    /; (\w+) bui.+ oppo/i,
    /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
  ],
  [MODEL, [VENDOR, "OPPO"], [TYPE, MOBILE]],
  [
    /vivo (\w+)(?: bui|\))/i,
    /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
  ],
  [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]],
  [
    /\b(rmx[12]\d{3})(?: bui|;|\))/i
  ],
  [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]],
  [
    /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
    /\bmot(?:orola)?[- ](\w*)/i,
    /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
  ],
  [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]],
  [/\b(mz60\d|xoom[2 ]{0,2}) build\//i],
  [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]],
  [
    /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
  ],
  [MODEL, [VENDOR, LG], [TYPE, TABLET]],
  [
    /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
    /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
    /\blg-?([\d\w]+) bui/i
  ],
  [MODEL, [VENDOR, LG], [TYPE, MOBILE]],
  [
    /(ideatab[-\w ]+)/i,
    /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
  ],
  [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]],
  [
    /(?:maemo|nokia).*(n900|lumia \d+)/i,
    /nokia[-_ ]?([-\w\.]*)/i
  ],
  [
    [MODEL, /_/g, " "],
    [VENDOR, "Nokia"],
    [TYPE, MOBILE]
  ],
  [
    /(pixel c)\b/i
  ],
  [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]],
  [
    /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
  ],
  [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]],
  [
    /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
  ],
  [MODEL, [VENDOR, SONY], [TYPE, MOBILE]],
  [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i],
  [
    [MODEL, "Xperia Tablet"],
    [VENDOR, SONY],
    [TYPE, TABLET]
  ],
  [
    / (kb2005|in20[12]5|be20[12][59])\b/i,
    /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
  ],
  [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]],
  [
    /(alexa)webm/i,
    /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
    /(kf[a-z]+)( bui|\)).+silk\//i
  ],
  [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]],
  [
    /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
  ],
  [
    [MODEL, /(.+)/g, "Fire Phone $1"],
    [VENDOR, AMAZON],
    [TYPE, MOBILE]
  ],
  [
    /(playbook);[-\w\),; ]+(rim)/i
  ],
  [MODEL, VENDOR, [TYPE, TABLET]],
  [
    /\b((?:bb[a-f]|st[hv])100-\d)/i,
    /\(bb10; (\w+)/i
  ],
  [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]],
  [
    /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
  ],
  [MODEL, [VENDOR, ASUS], [TYPE, TABLET]],
  [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i],
  [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]],
  [
    /(nexus 9)/i
  ],
  [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]],
  [
    /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
    /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
    /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
  ],
  [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]],
  [
    /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
  ],
  [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]],
  [
    /droid.+; (m[1-5] note) bui/i,
    /\bmz-([-\w]{2,})/i
  ],
  [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]],
  [
    /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
    /(hp) ([\w ]+\w)/i,
    /(asus)-?(\w+)/i,
    /(microsoft); (lumia[\w ]+)/i,
    /(lenovo)[-_ ]?([-\w]+)/i,
    /(jolla)/i,
    /(oppo) ?([\w ]+) bui/i
  ],
  [VENDOR, MODEL, [TYPE, MOBILE]],
  [
    /(kobo)\s(ereader|touch)/i,
    /(archos) (gamepad2?)/i,
    /(hp).+(touchpad(?!.+tablet)|tablet)/i,
    /(kindle)\/([\w\.]+)/i
  ],
  [VENDOR, MODEL, [TYPE, TABLET]],
  [
    /(surface duo)/i
  ],
  [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]],
  [
    /droid [\d\.]+; (fp\du?)(?: b|\))/i
  ],
  [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]],
  [
    /(shield[\w ]+) b/i
  ],
  [MODEL, [VENDOR, "Nvidia"], [TYPE, TABLET]],
  [
    /(sprint) (\w+)/i
  ],
  [VENDOR, MODEL, [TYPE, MOBILE]],
  [
    /(kin\.[onetw]{3})/i
  ],
  [
    [MODEL, /\./g, " "],
    [VENDOR, MICROSOFT],
    [TYPE, MOBILE]
  ],
  [
    /droid.+; ([c6]+|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
  ],
  [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]],
  [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i],
  [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]],
  [
    /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
  ],
  [MODEL, [TYPE, MOBILE]],
  [
    /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
  ],
  [MODEL, [TYPE, TABLET]],
  [
    /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
  ],
  [[TYPE, TABLET]],
  [
    /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
  ],
  [[TYPE, MOBILE]],
  [
    /(android[-\w\. ]{0,9});.+buil/i
  ],
  [MODEL, [VENDOR, "Generic"]]
];
const osRegexes = [
  [
    /microsoft (windows) (vista|xp)/i
  ],
  [NAME, VERSION],
  [
    /(windows) nt 6\.2; (arm)/i,
    /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
    /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
  ],
  [NAME, [VERSION, strMapper, windowsVersionMap]],
  [/(win(?=3|9|n)|win 9x )([nt\d\.]+)/i],
  [
    [NAME, WINDOWS],
    [VERSION, strMapper, windowsVersionMap]
  ],
  [
    /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
    /ios;fbsv\/([\d\.]+)/i,
    /cfnetwork\/.+darwin/i
  ],
  [
    [VERSION, /_/g, "."],
    [NAME, "iOS"]
  ],
  [
    /(mac os x) ?([\w\. ]*)/i,
    /(macintosh|mac_powerpc\b)(?!.+haiku)/i
  ],
  [
    [NAME, "Mac OS"],
    [VERSION, /_/g, "."]
  ],
  [
    /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
  ],
  [VERSION, NAME],
  [
    /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
    /(blackberry)\w*\/([\w\.]*)/i,
    /(tizen|kaios)[\/ ]([\w\.]+)/i,
    /\((series40);/i
  ],
  [NAME, VERSION],
  [
    /\(bb(10);/i
  ],
  [VERSION, [NAME, BLACKBERRY]],
  [
    /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
  ],
  [VERSION, [NAME, "Symbian"]],
  [
    /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
  ],
  [VERSION, [NAME, FIREFOX + " OS"]],
  [
    /web0s;.+rt(tv)/i,
    /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
  ],
  [VERSION, [NAME, "webOS"]],
  [
    /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
  ],
  [VERSION, [NAME, "watchOS"]],
  [
    /crkey\/([\d\.]+)/i
  ],
  [VERSION, [NAME, CHROME + "cast"]],
  [
    /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
  ],
  [[NAME, "Chrome OS"], VERSION],
  [
    /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
    /(mint)[\/\(\) ]?(\w*)/i,
    /(mageia|vectorlinux)[; ]/i,
    /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
    /(hurd|linux) ?([\w\.]*)/i,
    /(gnu) ?([\w\.]*)/i,
    /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
    /(haiku) (\w+)/i
  ],
  [NAME, VERSION],
  [
    /(sunos) ?([\w\.\d]*)/i
  ],
  [[NAME, "Solaris"], VERSION],
  [
    /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
    /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
    /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
    /(unix) ?([\w\.]*)/i
  ],
  [NAME, VERSION]
];
const defaultRegexes = {
  browser: browserRegexes,
  device: deviceRegexes,
  os: osRegexes
};
const NAVIGATOR = typeof window === "undefined" ? void 0 : window.navigator;
const NAVIGATOR_UADATA = (NAVIGATOR == null ? void 0 : NAVIGATOR.userAgentData) || void 0;
const defaultProps = {
  init: {
    [`${UA_BROWSER}`]: [NAME, VERSION, MAJOR],
    [`${UA_DEVICE}`]: [TYPE, MODEL, VENDOR],
    [`${UA_OS}`]: [NAME, VERSION]
  },
  isIgnore: { [`${UA_BROWSER}`]: [VERSION, MAJOR], [`${UA_OS}`]: [VERSION] },
  isIgnoreRgx: { [`${UA_BROWSER}`]: / ?browser$/i, [`${UA_OS}`]: / ?os$/i },
  toString: {
    [`${UA_BROWSER}`]: [NAME, VERSION],
    [`${UA_DEVICE}`]: [VENDOR, MODEL],
    [`${UA_OS}`]: [NAME, VERSION]
  }
};
const createUAParserData = function(itemType) {
  const init_props = defaultProps.init[itemType];
  class UAParserData {
    constructor() {
      assignFromEntries(this, init_props);
    }
  }
  return new UAParserData();
};
class UAParserDataCH {
  constructor(uach, isHTTP_UACH) {
    uach = uach || {};
    assignFromEntries(this, CH_ALL_VALUES);
    if (isHTTP_UACH) {
      assignFromEntries(this, [
        [BRANDS, itemListToArray(uach[CH_HEADER])],
        [FULLVERLIST, itemListToArray(uach[CH_HEADER_FULL_VER_LIST])],
        [MOBILE, /\?1/.test(uach[CH_HEADER_MOBILE])],
        [MODEL, stripQuotes(uach[CH_HEADER_MODEL])],
        [PLATFORM, stripQuotes(uach[CH_HEADER_PLATFORM])],
        [PLATFORMVER, stripQuotes(uach[CH_HEADER_PLATFORM_VER])],
        [ARCHITECTURE, stripQuotes(uach[CH_HEADER_ARCH])],
        [BITNESS, stripQuotes(uach[CH_HEADER_BITNESS])]
      ]);
    } else {
      for (const prop in uach) {
        if (this.hasOwnProperty(prop) && typeof uach[prop] !== UNDEF_TYPE) {
          this[prop] = uach[prop];
        }
      }
    }
    return this;
  }
}
class UAParserItem {
  constructor(itemType, ua, rgxMap, uaCH) {
    __publicField(this, "itemType");
    __publicField(this, "ua");
    __publicField(this, "rgxMap");
    __publicField(this, "uaCH");
    __publicField(this, "data");
    this.itemType = itemType;
    this.ua = ua;
    this.rgxMap = rgxMap;
    this.uaCH = uaCH;
    this.data = createUAParserData(itemType);
    if (this.itemType == UA_RESULT) {
      const createUAParserItem = function(itemType2) {
        return new UAParserItem(itemType2, ua, rgxMap[itemType2], uaCH).parseUA().get();
      };
      this.set("ua", ua).set(UA_BROWSER, createUAParserItem(UA_BROWSER)).set(UA_DEVICE, createUAParserItem(UA_DEVICE)).set(UA_OS, createUAParserItem(UA_OS)).get();
    }
    return this;
  }
  detectFeature() {
    const isSelfNav = NAVIGATOR && NAVIGATOR.userAgent == this.ua;
    switch (this.itemType) {
      case UA_BROWSER:
        if (isSelfNav && (NAVIGATOR == null ? void 0 : NAVIGATOR.brave) && typeof NAVIGATOR.brave.isBrave == FUNC_TYPE) {
          this.set(NAME, "Brave");
        }
        this.set(MAJOR, majorize(this.get(VERSION)));
        break;
      case UA_DEVICE:
        if (isSelfNav && !this.get(TYPE) && NAVIGATOR_UADATA && NAVIGATOR_UADATA[MOBILE]) {
          this.set(TYPE, MOBILE);
        }
        if (isSelfNav && this.get(MODEL) == "Macintosh" && NAVIGATOR && typeof NAVIGATOR.standalone !== UNDEF_TYPE && NAVIGATOR.maxTouchPoints && NAVIGATOR.maxTouchPoints > 2) {
          this.set(MODEL, "iPad").set(TYPE, TABLET);
        }
        break;
      case UA_OS:
        if (isSelfNav && !this.get(NAME) && NAVIGATOR_UADATA && NAVIGATOR_UADATA[PLATFORM]) {
          this.set(NAME, NAVIGATOR_UADATA[PLATFORM]);
        }
    }
    return this;
  }
  get(prop) {
    if (!prop)
      return this.data;
    return this.data.hasOwnProperty(prop) ? this.data[prop] : void 0;
  }
  parseUA() {
    if (this.itemType != UA_RESULT) {
      rgxMapper(this.data, this.ua, this.rgxMap);
    }
    this.detectFeature();
    return this;
  }
  set(prop, val) {
    this.data[prop] = val;
    return this;
  }
}
class UAParser {
  constructor(ua) {
    __publicField(this, "userAgent", EMPTY);
    __publicField(this, "httpUach", {});
    this.init(ua);
  }
  init(ua) {
    if (!(this instanceof UAParser)) {
      return new UAParser(ua).getResult();
    }
    this.userAgent = ua || (NAVIGATOR == null ? void 0 : NAVIGATOR.userAgent) || EMPTY;
    this.httpUach = new UAParserDataCH({}, true);
    this.setUA(this.userAgent);
    return this;
  }
  createUAParserItemFunc(itemType) {
    const rgxMap = itemType === UA_RESULT ? defaultRegexes : defaultRegexes[itemType];
    return new UAParserItem(itemType, this.userAgent, rgxMap, this.httpUach).parseUA().get();
  }
  getBrowser() {
    return this.createUAParserItemFunc(UA_BROWSER);
  }
  getDevice() {
    return this.createUAParserItemFunc(UA_DEVICE);
  }
  getOS() {
    return this.createUAParserItemFunc(UA_OS);
  }
  getUA() {
    return this.userAgent;
  }
  setUA(ua) {
    this.userAgent = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
    return this;
  }
  getResult() {
    return this.createUAParserItemFunc(UA_RESULT);
  }
}
const historyCacheResult = {};
function parse(ua, isFormat = false, isCache = true) {
  const key = `${ua}_isForma=${isFormat}`;
  if (ua && historyCacheResult[key] && isCache) {
    return historyCacheResult[key];
  }
  const result = new UAParser(ua).getResult();
  const { browser: browserInfo, device: deviceInfo, os: osInfo } = result;
  const { name: browser = "", version: _browserVersion } = browserInfo;
  const liteVersion = (_browserVersion == null ? void 0 : _browserVersion.replace(/(\d+\.\d+)(\.\d+)*/, "$1")) || "";
  const bi = `${browser}/${liteVersion}`;
  const { name: osName = "", version: osVersion = "" } = osInfo;
  const os = `${osName}/${osVersion}`;
  const usData = isFormat ? {
    os,
    osName,
    osVersion,
    bi,
    browser,
    browserVersion: Number.parseInt(liteVersion, 10) || 0,
    deviceType: deviceInfo.type || "",
    deviceCompany: deviceInfo.vendor || "",
    deviceModel: deviceInfo.model || ""
  } : result;
  historyCacheResult[key] = usData;
  return usData;
}
export { parse };
